import { Col, Image, Row } from 'antd'
import { CaretRightOutlined } from '@ant-design/icons'
import classNames from 'classnames'
import { Scrollbars } from 'react-custom-scrollbars'
import { useShallow } from 'zustand/react/shallow'
import { useFileUrlPrefix } from 'shj-utils'
import useWorkOrderStore from '@/store/workOrder.ts'
import styles from './index.module.less'
import { useRef } from 'react'

const WorkOrderAppList = props => {
  const { onSelect } = props

  const [urlPrefix] = useFileUrlPrefix()
  const { storeData, setWorkOrderExpandKeys, selectWorkOrderApp } = useWorkOrderStore(
    useShallow((state: any) => ({
      storeData: state.data,
      setWorkOrderExpandKeys: state.setWorkOrderExpandKeys,
      selectWorkOrderApp: state.selectWorkOrderApp,
    }))
  )

  const handleCollapseChange = keys => {
    setWorkOrderExpandKeys(keys)
  }

  const onAppSelect = (tab, record) => {
    selectWorkOrderApp(tab.key, record)
    onSelect?.(tab, record)
  }
  
  return (
    <div className={styles.workOrderCollect}>
      <Scrollbars autoHide renderTrackHorizontal={() => <div></div>}>
        <AppCollapseList
          dataSource={storeData.workOrderCollect}
          countData={storeData.workOrderCount}
          parent={null}
          itemSelected={storeData.selectedTabKey + (storeData.selectedAppCode || '')}
          onSelect={onAppSelect}
          urlPrefix={urlPrefix}
          activeKey={storeData.workOrderExpandKeys}
          onChange={handleCollapseChange}
        />
      </Scrollbars>
    </div>
  )
}

const countStyle = { flexShrink: 0, paddingRight: 8, color: '#999' }

const AppTab = props => {
  const { data, countData, activeKey, onChange, parent, onSelect, itemSelected } = props
  const ref = useRef<any>()

  const isActive = activeKey.includes(data.key)

  const handleToggle = e => {
    e.stopPropagation()
    onChange?.(isActive ? activeKey.filter(k => k !== data.key) : [...activeKey, data.key])
  }

  const isSelected = itemSelected === (parent?.key || '') + data.key
  // console.log('itemSelected', itemSelected)
  return (
    <div className={styles.workOrderWrap}>
      <Row
        justify="space-between"
        className={classNames(styles.workOrderTab, { [styles.selected]: isSelected })}
        onClick={() => onSelect?.(data)}
      >
        <Col>
          <Row align="middle" gutter={8}>
            <Col style={{ padding: '2px 4px' }} onClick={handleToggle}>
              <CaretRightOutlined rotate={isActive ? 90 : 0} style={{ color: '#333' }} />
            </Col>
            <Col>
              <div className={styles.workOrderCollectTitle}>{data.name}</div>
            </Col>
          </Row>
        </Col>
        <Col style={{ ...countStyle, paddingRight: 0 }}>
          {data.countKey ? countData[data.countKey] : ''}
        </Col>
      </Row>
      <div className={classNames(styles.collapseWrap, { [styles.active]: isActive })} ref={ref}>
        <AppCollapseList {...props} dataSource={data.data} parent={data} />
      </div>
    </div>
  )
}

const AppCollapseList = props => {
  const { dataSource, countData, urlPrefix, parent, itemSelected, onSelect } = props
  return dataSource.map((d, i) => {
    if (Array.isArray(d.data)) {
      return <AppTab {...props} key={d.key} data={d} countData={countData} />
    }
    const isSelected = itemSelected === (parent?.key || '') + d.key
    return (
      <div
        className={classNames(styles.workOrderApp, {
          [styles.selected]: isSelected,
        })}
        key={d.key}
        onClick={() => onSelect?.(parent, d)}
      >
        <Row gutter={8} align="middle" justify="space-between" wrap={false}>
          <Col>
            <Image width={24} height={24} src={d?.icon?.startsWith?.('http') ? d.icon : urlPrefix + d.icon} preview={false} />
          </Col>
          <Col
            flex={1}
            style={{
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          >
            {d.name}
          </Col>
          <Col style={countStyle}>{d.unFinished}</Col>
        </Row>
      </div>
    )
  })
}

export default WorkOrderAppList
